import { render } from "./NoteDetail.vue?vue&type=template&id=83d7e57e&scoped=true"
import script from "./NoteDetail.vue?vue&type=script&lang=js"
export * from "./NoteDetail.vue?vue&type=script&lang=js"

import "./NoteDetail.vue?vue&type=style&index=0&id=83d7e57e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d7e57e"]])

export default __exports__